/* eslint-disable no-fallthrough */
import * as TYPES from './DrivingDirections.types';

const initialState = {
  directions: [],
  selectedDirection: {},
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_DRIVING_DIRECTIONS_LIST_SUCCESS: {
      return {
        ...state,
        directions: action?.result?.data,
      };
    }

    case TYPES.GET_DRIVING_DIRECTION_SUCCESS: {
      return {
        ...state,
        selectedDirection: {
          ...action?.result?.data,
          loadedAt: Date.now(),
        },
      };
    }

    case TYPES.CLEAR_SELECTED_DIRECTION: {
      return {
        ...state,
        selectedDirection: {},
      };
    }

    default:
      return state;
  }
};

export default reducer;
